import React, { FC } from 'react';
import styles from './index.module.scss';
import { keepTwoOrLine } from '../../utils';

export interface IEachCard {
  img: string;
  lineOne: { label: string; value?: number; unit?: string };
  lineTwo: { label: string; value?: number; unit?: string };
}

const EachCard: FC<IEachCard> = props => {
  const { img, lineOne, lineTwo } = props;
  return (
    <div className={styles.each_card_box}>
      <img className={styles.imgSty} src={img} alt="" />
      <div className={styles.value_box}>
        <div className={styles.value_eachline_box}>
          <div className={styles.label}>{lineOne.label}：</div>
          <div className={styles.blue_value}>
            {keepTwoOrLine(lineOne.value)}
            {lineOne.unit}
          </div>
        </div>
        <div className={styles.value_eachline_box}>
          <div className={styles.label}>{lineTwo.label}：</div>
          <div className={styles.yellow_value}>
            {keepTwoOrLine(lineTwo.value)}
            {lineOne.unit}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EachCard;
